import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Segmented
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { TrainingAPI } from "../../api/TrainingAPI";

export const OutliersTable = ({ outliers, setUpdatedOutliers, onCancel, parentSubmitHandler }) => {
  const [columns, setColumns] = useState([]);
  const [localOutliers, setLocalOutliers] = useState([]);
  const localOutliersRef = useRef(localOutliers);

  useEffect(() => {
    const outlierColumns = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        sorter: {
          compare: (a, b) => a.date.localeCompare(b.date),
          multiple: 1,
        },
        render: (date, data) => {
          return <>{date}</>;
        },
      },
      {
        title: "Player",
        dataIndex: "player_id",
        key: "player_id",
        sorter: {
          compare: (a, b) => a.player_name.localeCompare(b.player_name),
          multiple: 3,
        },
        render: (player_id, data) => {
          return (
            <>
              {data.player_name}
            </>
          );
        },
      },
      {
        title: "Session",
        dataIndex: "session",
        key: "session",
        sorter: {
          compare: (a, b) => a.session.localeCompare(b.session),
          multiple: 3,
        },
        render: (session, data) => {
          return (
            <>
              {data.session}
            </>
          );
        },
      },
      {
        title: "Metric Name",
        dataIndex: "metric_name",
        key: "metric_name",
        sorter: {
          compare: (a, b) => a.metric_name.localeCompare(b.metric_name),
          multiple: 1,
        },
        render: (metric_name, data) => {
          return <>{metric_name}</>;
        },
      },
      {
        title: "Value",
        dataIndex: "value",
        key: "value",
        sorter: {
          compare: (a, b) => a.value - b.value,
          multiple: 1,
        },
        render: (value, data) => {
          return <>{value}</>;
        },
      },
      {
        title: "ATH",
        dataIndex: "ath",
        key: "ath",
        sorter: {
          compare: (a, b) => a.ath - b.ath,
          multiple: 1,
        },
        render: (ath, data) => {
          return <>{ath}</>;
        },
      },
      {
        title: "% Diff",
        dataIndex: "perc_diff",
        key: "perc_diff",
        sorter: {
          compare: (a, b) => a.perc_diff - b.perc_diff,
          multiple: 1,
        },
        render: (perc_diff, data) => {
          return <>{perc_diff}</>;
        },
      },
      {
        title: "Action",
        dataIndex: "action",
        width: "10%",
        key: "action",
        render: (action, data, index) => {
          return (
            <Segmented
              options={[
                { 
                  label: <span style={{ color: '#b30000', fontWeight: '700' }}>Skip</span>, 
                  value: 'skip'
                },
                { 
                  label: <span style={{ color: '#006600', fontWeight: '700' }}>Mark as Valid</span>, 
                  value: 'valid'
                },
              ]}
              value={action}
              onChange={(value) => {
                let updatedOutliers = [...localOutliers];
                updatedOutliers[index] = { ...updatedOutliers[index], action: value };
                localOutliersRef.current = updatedOutliers;
                setLocalOutliers(updatedOutliers);
              }}
            />
          )
        },
      },
    ];

    setColumns(outlierColumns);
  }, [localOutliers]);

  useEffect(() => {
    if (Object.entries(outliers.length) === 0)
      return 

    setLocalOutliers(outliers);
    
  }, [outliers]);

  const onSubmit = (e) => {
    const findBlankActionsSelections = localOutliers.filter((outlier) => outlier.action === null);
    if (findBlankActionsSelections.length > 0) {
      message.error("Please select actions for all presented outliers.")
    } else {
      setUpdatedOutliers(localOutliers);
      onCancel(e);
    }
  };

  return (
    <>
      <Button type="primary" onClick={e => onSubmit(e)}>
        Submit Actions
      </Button>
      <Table
        rowKey="rowId"
        columns={columns}
        size="small"
        dataSource={localOutliers}
        style={{ width: "100%", maxWidth: "100%" }}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          position: ["topLeft"],
        }}
      />
    </>
  );
};
